<template>
    <div
        class="px-4 py-3 bg-yellow-100 border-t border-yellow-200 flex items-center gap-x-2 text-sm text-yellow-800"
        data-testid="communicating-conflict-banner"
        v-if="communicatingLead"
    >
        <activix-icon
            class="flex-shrink-0 text-base"
            :name="communicatingLeadIcon"
            v-if="communicatingLeadIcon"
        />

        <span>{{ communicatingLeadMessage }}</span>
    </div>

    <div
        class="px-4 py-3 bg-blue-50 border-t border-blue-200 flex items-center gap-x-2 text-sm text-blue-800"
        data-testid="communicating-recent-banner"
        v-else-if="recentCommunication"
    >
        <activix-icon
            class="flex-shrink-0 text-base"
            :name="recentCommunicationResolvedIcon"
            v-if="recentCommunicationResolvedIcon"
        />

        <span>{{ recentCommunicationResolvedMessage }}</span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import ActivixIcon from '@/components/elements/ActivixIcon.vue';
    import {
        useLeadCommunicating,
        type CommunicatingLead,
        type RecentCommunication,
    } from '@/entities/lead/useLeadCommunicating.ts';

    const props = defineProps<{
        communicatingLead: CommunicatingLead | null;
        recentCommunication: RecentCommunication | null;
    }>();

    const {
        communicatingMessage,
        communicatingIcon,
        recentCommunicationMessage,
        recentCommunicationIcon,
    } = useLeadCommunicating();

    const communicatingLeadMessage = computed(() => {
        return communicatingMessage(props.communicatingLead);
    });

    const communicatingLeadIcon = computed(() => {
        return communicatingIcon(props.communicatingLead);
    });

    const recentCommunicationResolvedMessage = computed(() => {
        return recentCommunicationMessage(props.recentCommunication);
    });

    const recentCommunicationResolvedIcon = computed(() => {
        return recentCommunicationIcon(props.recentCommunication);
    });
</script>
